export default "__VITE_ASSET__19530f23__"